import { footerDownloadAppQueryOptions } from '@/services/queryOptions/footerDownloadAppQueryOptions';
import { useSuspenseQuery } from '@tanstack/react-query';
import { match } from 'ts-pattern';
import { CMSText } from '../cms/cms-text';
import { cn } from '@/lib/utils';
import { CMSPlaceholder } from '../cms/cms-placeholder';

const DownloadApp = () => {
  const { data: footerDownload, isError } = useSuspenseQuery(
    footerDownloadAppQueryOptions
  );

  if (isError) {
    return null;
  }

  return (
    <div className="w-full">
      {footerDownload.content.map((content, index) =>
        match(content)
          .with({ type: 'text' } as const, (textData) => (
            <CMSText
              key={index}
              textData={textData}
              className={cn(
                // Add margin bottom if CMSText is first child then apply it to first child paragraph
                '[&:first-child_p:first-child]:mb-4',

                '[&_p]:text-sm lg:[&_p]:text-base [&_p]:text-white [&_p]:mb-2',

                // Add style for tag that has a tag
                '[&_p_a]:text-sm lg:[&_p_a]:text-base [&_p_a]:cursor-pointer [&_p_a]:no-underline [&_p_a]:text-white',

                // Add style for bold tag
                '[&_p_strong]:text-white [&_p_strong]:font-nunito700',

                // Add style for CTA
                '[&_[data-component="CMSCTAButton"]_a]:no-underline [&_[data-component="CMSCTAButton"]_a]:text-sm lg:[&_[data-component="CMSCTAButton"]_a]:text-base [&_[data-component="CMSCTAButton"]_a]:text-white [&_[data-component="CMSCTAButton"]_a]:font-light'
              )}
            />
          ))
          .with({ type: 'placeholder' } as const, (data) => (
            <CMSPlaceholder
              isFromFooter
              className={cn(
                // Set margin top and margin bottom for CMSAppLinks
                '[&_[data-component="CMSAppLinks"]]:mt-4 [&_[data-component="CMSAppLinks"]]:mb-8',

                // Add gap for CMSAppLinks
                '[&_[data-component="CMSAppLinks"]]:gap-[6px]',

                // Set width for CMSAppLinks
                '[&_[data-component="CMSAppLinks"]_img]:w-[125px]'
              )}
              key={index}
              placeholderData={data}
            />
          ))
          .otherwise(() => <div key={index}>Unhandled CMSComponent</div>)
      )}
    </div>
  );
};

export { DownloadApp };
